export default "__VITE_ASSET__C_Y_UxdU__"